import { StaticImage } from 'gatsby-plugin-image';
import * as React from 'react';

import { classNames } from '../../utils/classnames';
import { ContactForm } from '../contact-form';
import { ContactInfo } from '../contact-info';

interface ContactSectionProps {
  title: string;
}

function ContactSection({ title }: ContactSectionProps): JSX.Element {
  return (
    <div id="contact-form" className={classNames('bg-dark ')}>
      <div className="relative z-0 w-full px-4 py-12 mx-auto max-w-prose lg:py-24 lg:max-w-screen-2xl sm:px-6 lg:px-8">
        <div className="grid gap-8 lg:grid-cols-2">
          <div style={{ zIndex: 1 }} className="relative">
            <ContactInfo title="Contact us" />
          </div>
          <div style={{ zIndex: 1 }} className="relative">
            <ContactForm title={title} />
          </div>
          <div style={{ zIndex: 0 }} className="relative">
            {title === 'Contact' ? (
              <div className="absolute -top-96 -left-28">
                <StaticImage
                  src="../../images/assets/clock.png"
                  alt="asset"
                  className=""
                />
              </div>
            ) : (
              <div className="absolute -left-72 -top-96">
                <StaticImage
                  src="../../images/assets/thumbs-contact-section.png"
                  alt="asset"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export { ContactSection };
